import { motion, useInView } from "framer-motion";
import { useRef, useState } from "react";
import { questions } from "../../utilities/homeData";
import Accordion from "./accordion";
import DefaultSpacing from "../../utilities/constants";

const FaqSection = () => {
  const [isOpen, setIsOpen] = useState(null);
  const faqRef = useRef();
  const faqIsInView = useInView(faqRef, { amount: 0.5, once: true });

  const ref = useRef();
  const isInView = useInView(ref, { amount: 0.5, once: true });

  const verticaleAnimation = {
    hidden: {
      opacity: 0,
      y: "50%",
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.3,
        duration: 0.5,
      },
    },
  };

  const staggeredAnimation = {
    hidden: {
      opacity: 0,
      x: "50%",
    },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.15 * index,
        duration: 0.5,
      },
    }),
  };

  const defaultSpacing = new DefaultSpacing();
  const gap = defaultSpacing.getDefaultGap();

  return (
    <>
      <div
        ref={ref}
        className={`grid grid-cols-1 overflow-hidden lg:grid-cols-2 ${gap}`}
      >
        <motion.div
          variants={verticaleAnimation}
          initial={"hidden"}
          animate={isInView ? "visible" : "hidden"}
          className="col-span-1"
        >
          <p className="text-xl font-light uppercase">still not sure?</p>
          <h1 className="py-5 text-4xl font-bold leading-[3.48rem] md:text-[2.875rem]">
            Frequently
            <br />
            Asked Questions
          </h1>
          <hr className="h-[3px] w-2/5 border-none bg-visOrange" />
          <p className="py-5 text-xl font-normal">
            Want to learn more about Us? Here’s everything that you need to
            know.
          </p>
        </motion.div>
        <div ref={faqRef} className="col-span-1">
          <div className="w-full space-y-3">
            {questions.map((item, index) => {
              return (
                <motion.div
                  key={index + item.question}
                  variants={staggeredAnimation}
                  initial={"hidden"}
                  animate={faqIsInView ? "visible" : "hidden"}
                  custom={index}
                  className="flex flex-col overflow-hidden shadow-visBoxShadow rounded-sm"
                >
                  <Accordion
                    isOpen={isOpen === index}
                    onClick={() => setIsOpen(isOpen === index ? null : index)}
                    question={item.question}
                    answer={item.answer}
                  />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqSection;
